import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { setWeight, setLowActivity, setHighActivity } from "../../store/personalSlice";
import { colors, space, borders } from "../../design/tokens";
import { TextInput, Row } from "../layout";

function validate(values) {
  const e = {};
  if (values.weight && (values.weight < 30 || values.weight > 300))
    e.weight = "30–300 kg";
  if (values.lowActivityMin && (values.lowActivityMin < 0 || values.lowActivityMin > 300))
    e.lowActivityMin = "0–300 min";
  if (values.highActivityMin && (values.highActivityMin < 0 || values.highActivityMin > 180))
    e.highActivityMin = "0–180 min";
  return e;
}

export default function TodayPersonalInputs() {
  const dispatch = useDispatch();

  const today = new Date().toISOString().split("T")[0];
  const personal = useSelector((state) => state.personal.byDate[today] || {});

  const { control, getValues } = useForm({
    defaultValues: {
      weight: personal.weight || "",
      lowActivityMin: personal.lowActivityMin || "",
      highActivityMin: personal.highActivityMin || "",
    },
    mode: "onChange",
  });

  const field = (name, label, onDispatch) => (
    <Controller
      key={name}
      control={control}
      name={name}
      rules={{
        validate: (value) => {
          const errs = validate({ ...getValues(), [name]: value });
          return errs[name] || true;
        },
      }}
      render={({ field, fieldState }) => (
        <TextInput
          label={label}
          error={fieldState.error?.message}
          value={field.value}
          onBlur={() => {
            field.onBlur();
            if (!fieldState.error) onDispatch(Number(field.value));
          }}
          ref={field.ref}
          onChange={(e) => {
            field.onChange(e.target.value); // keep as string while typing
          }}
          slim
          style={{
            background: colors.surfaceSoft,
            borderBottom: borders.sm,
            borderColor: fieldState.error ? "red" : colors.primary,
            color: fieldState.error ? "red" : colors.text,
          }}
        />
      )}
    />
  );

  return (
    <Row flex={[1, 1, 1]}>
      {field("weight", "Weight (kg)", (val) =>
        dispatch(setWeight({ date: today, weight: val }))
      )}
      {field("lowActivityMin", "Low Activity (min)", (val) =>
        dispatch(setLowActivity({ date: today, minutes: val }))
      )}
      {field("highActivityMin", "High Activity (min)", (val) =>
        dispatch(setHighActivity({ date: today, minutes: val }))
      )}
    </Row>
  );
}